const TableRestaurantIcon = (
  <svg
    className="fill-none"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 3V10M18 3V10M4 10H20M8 10V21M16 10V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TableRestaurantIcon;